import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSoyuzClientConfig, useSoyuzLocales } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import { HeaderContainer as HeaderContainerComponent } from '@spotahome/ui-library';

import { useLocaleChange } from '../hooks/useLocaleChange';

import { getLoggedInUserInfo } from '../api/auth-client';

const SESSION_EXPIRED_STATUS = 401;

const HeaderContainer = props => {
  const clientConfig = useSoyuzClientConfig();
  const handleOnLocaleChange = useLocaleChange();
  const { current } = useSoyuzLocales();
  const [isTenantLogged, setIsTenantLogged] = useState(false);

  async function requestLoggedInUserInfo() {
    try {
      const response = await getLoggedInUserInfo();
      const userId = response.data.id;
      if (userId) {
        setIsTenantLogged(true);
      }
      return response;
    } catch (err) {
      if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
        Mediator.publish('AUTH_MODAL_OPEN', { initialAction: 'login' });
        setIsTenantLogged(false);
        return null;
      }
      throw new Error(err);
    }
  }

  return (
    <HeaderContainerComponent
      transparent
      color={props.color}
      locales={{ current, onChange: handleOnLocaleChange }}
      localeToggle={{ chinese: clientConfig.featureToggle.chinese }}
      login={{
        getLoggedInUserInfo: requestLoggedInUserInfo
      }}
      isTopTenantVariant
      isTenantLogged={isTenantLogged}
      isContactUsEnabled
      {...props}
    />
  );
};

HeaderContainer.defaultProps = {
  color: 'dark',
  tracking: '',
  links: {}
};

HeaderContainer.propTypes = {
  color: PropTypes.string,
  tracking: PropTypes.string,
  links: PropTypes.shape({
    listYourProperty: PropTypes.oneOf([PropTypes.bool, PropTypes.shape({})]),
    tenantLandingPage: PropTypes.oneOf([PropTypes.bool, PropTypes.shape({})])
  })
};

export default HeaderContainer;
